import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';
//fill={props.color? props.color: "currentColor"}

export const ArrowDownIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} {...props} viewBox="0 0 12 14" ratio={12 / 14}>
            <path
                d="M5.60002 13.5999L0.350024 8.4249C0.125024 8.1999 0.125024 7.8499 0.350024 7.6249C0.575024 7.3999 0.925024 7.3999 1.15002 7.6249L5.42502 11.8249L5.42503 1.1999C5.42503 0.899902 5.67502 0.649903 5.97502 0.649903C6.27502 0.649903 6.55003 0.899903 6.55003 1.1999L6.55002 11.8749L10.875 7.6249C11.1 7.3999 11.45 7.3999 11.675 7.6249C11.775 7.7249 11.825 7.8749 11.825 8.0249C11.825 8.1749 11.775 8.3249 11.65 8.4249L6.40002 13.5999C6.17502 13.8249 5.82502 13.8249 5.60002 13.5999Z"
                fill={props.color? props.color: "currentColor"}/>
        </SvgIcon>
    );
}
